<template>
  <div
    class="ag-grid__overlay-form-box"
  >
    <div
      v-t="'ANNOTATE_CALLS'"
      class="ag-grid__overlay-form-box-title"
    />
    
    <div class="p-15">
      <div
        v-if="!callsReviewed"
        class="col-md-offset-3"
      >
        <BulkCallDetails
          :key="bulkCallReviewKey"
          :selected-calls="selectedCalls"
          @unselectCallOnBulkAction="unselectCallOnBulkAction"
        />
  
        <div>
          <button
            v-t="'CONTINUE'"
            class="btn btn-primary btn-sm m-t-15"
            @click="callsReviewed = true"
          />
  
          <button
            v-t="'CANCEL'"
            class="btn btn-danger btn-sm m-t-15 m-l-10"
            @click="hideBulkForm"
          />
        </div>
      </div>

      <div v-if="callsReviewed">
        <span
          class="clickable"
          @click="callsReviewed = false"
        >
          <i class="fa fa-chevron-left m-r-5" />
          {{ $t('REVIEW_CALLS') }}
        </span>
      
        <div class="container-fluid">
          <TagAnnotateForm
            :show-loader="showLoader"
            :recent-tags="recentTags"
            @closeForm="hideBulkForm"
            @annotateCallSubmit="annotateCalls"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import BulkCallDetails from '../BulkCallDetails';
import TagAnnotateForm from '../CallAnnotateForm/TagAnnotateForm';
import bulkCallActionMixin from './mixins/bulkCallActionMixin';

export default {
  name: 'BulkTagAnnotate',
  
  components: {
    BulkCallDetails,
    TagAnnotateForm,
  },

  mixins: [bulkCallActionMixin],

  props: {
    recentTags: {
      type: Array,
      default() {
        return [];
      }
    },
  },

  methods: {
    annotateCalls(tag) {
      this.$emit('annotateCalls', { 
        tag, 
        callIds: this.selectedCalls.map(call => call.inboundCallId)
      });
    }
  },

  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>

</style>